export default __webpack_public_path__ + "static/media/placeholderImageForYourAccount.b6c8c14e.svg";